// extracted by mini-css-extract-plugin
module.exports = {"invoiceDescription":"InvoiceDescription_invoiceDescription__2Oxly"};